export default "__VITE_ASSET__B$GOhcyA__"